import { render } from "./ExtraSmallLoader.vue?vue&type=template&id=04549b46&scoped=true"
const script = {}

import "./ExtraSmallLoader.vue?vue&type=style&index=0&id=04549b46&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04549b46"]])

export default __exports__